import type { ScheduleModeConfig } from '../schedule.types';

export const manualModeConfig: ScheduleModeConfig = {
  key: 'manual',
  navigationStyle: 'tabs',
  steps: [
    { key: 'details', label: 'Details' },
    { key: 'communication', label: 'Communication' },
    { key: 'scorecard', label: 'Scorecard' },
  ],
  showSecondaryCta: true,
};
